import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const api = axios.create({
  baseURL: `${API_URL}/api`,   // <-- add /api here
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/updateprofile', data),
  updatePassword: (data) => api.put('/auth/updatepassword', data),
};

// Course API
export const courseAPI = {
  getCourses: () => api.get('/courses'),
  getCourse: (id) => api.get(`/courses/${id}`),
  getMyCourses: () => api.get('/courses/my-courses'),
  purchaseCourse: (id) => api.post(`/courses/${id}/purchase`),
  activateCourse: (id) => api.put(`/courses/${id}/activate`),
  getFreeCourses: () => api.get('/courses/free'),
  getDemoStats: () => api.get('/courses/demo-stats'),
};

// Question API
export const questionAPI = {
  getQuestions: (courseId, params) => api.get(`/questions/${courseId}`, { params }),
  filterQuestions: (courseId, data) => api.post(`/questions/${courseId}/filter`, data),
  getQuestionStats: (courseId) => api.get(`/questions/${courseId}/stats`),
  getMasterAnalysis: (courseId) => api.get(`/questions/${courseId}/master-analysis`),
  getQuestionsByTags: (courseId) => api.post(`/questions/${courseId}/by-tags`),
  getQuestion: (id) => api.get(`/questions/detail/${id}`),
};

// Syllabus API
export const syllabusAPI = {
  getSyllabus: (courseId) => api.get(`/syllabus/${courseId}`),
};

export default api;
